import { SkeletonLoader, TooltipTrigger } from '@toggle/design-system';
import React from 'react';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';

import { ClickableScenarioInsightTooltip } from '../clickable-scenario-insight-tooltip/ClickableScenarioInsightTooltip';
import { useInsightsCellData } from '../hooks/useInsightsCellData';
import { InsightsIcon } from '../insights-icon/InsightsIcon';
import * as S from './InsightsScenarioCell.styles';

const MAX_SCENARIO_INSIGHTS = 4;

export type InsightsScenarioCellProps = {
  entityTag: string;
  isDisabled: boolean;
};

export const InsightsScenarioCell = ({
  entityTag,
  isDisabled,
}: InsightsScenarioCellProps) => {
  const { isLoading, filteredScenarioInsights } = useInsightsCellData({
    entityTag,
  });

  if (isLoading) {
    return (
      <SkeletonLoader
        areas={[
          {
            styles: {
              height: '20px',
              borderRadius: '8px',
            },
          },
        ]}
      />
    );
  }

  const visibleScenarioInsights =
    filteredScenarioInsights.length >= MAX_SCENARIO_INSIGHTS
      ? filteredScenarioInsights.slice(0, MAX_SCENARIO_INSIGHTS - 2)
      : filteredScenarioInsights.slice(0, MAX_SCENARIO_INSIGHTS);

  const remainingScenarioInsights =
    filteredScenarioInsights.length >= MAX_SCENARIO_INSIGHTS
      ? filteredScenarioInsights.slice(MAX_SCENARIO_INSIGHTS - 2)
      : filteredScenarioInsights.slice(MAX_SCENARIO_INSIGHTS);

  return (
    <S.InsightsContainer>
      {visibleScenarioInsights.map(insight => (
        <InsightsIcon
          key={insight.id}
          insight={insight}
          isDisabled={isDisabled}
          variant="assets-table"
          eventId={insight.eventId}
          read={insight.read}
        />
      ))}
      {!!remainingScenarioInsights.length && (
        <TooltipContainer
          label={
            <ClickableScenarioInsightTooltip
              insights={remainingScenarioInsights}
              entityTag={entityTag}
            />
          }
          inPortal
          trigger={[TooltipTrigger.Hover]}
          placement="top-end"
          withSafePolygon
          disabled={isDisabled}
        >
          <S.Count $isDisabled={isDisabled}>
            +{remainingScenarioInsights.length}
          </S.Count>
        </TooltipContainer>
      )}
    </S.InsightsContainer>
  );
};
